import React, { PureComponent } from "react";
import styles from "./StatusWidgetContainer.module.scss";
import SingleSelectContainer from "components/ui_components/smart_input/SingleSelectContainer";

import { statusTabConfig } from "config/resources/requisitionsResource";
import helpers from "utils/helpers";
import { userGroups } from "config/userRoles";
import WidgetType1 from "components/ui_components/Widgets/WidgetType1/WidgetType1";
import InputWrap from "components/ui_components/smart_input/InputWrap";


// Import both status and billing status configurations
const { inputsByHash: statusInputsByHash, inputsById: statusInputsById } = statusTabConfig.statusWidget;


class StatusWidgetContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      statusTypes: [],
    };
  }

  render() {
    const { reqReasons } = this.state;
    const { reqID, reqStatusCode, reqBillStatusDesc, handleRequisitionUpdate } = this.props;

    return (
      <><WidgetType1
        title="Requisition Status"
        wrapStyles="width: 40%"
      >
        <div className={styles.inputList}>
          {statusInputsById.map((inputId, index) => {
            const input = statusInputsByHash[inputId];

            let params = { inputId, input };
            return (
              <InputWrap key={index}>
                <SingleSelectContainer
                  {...params}
                  reqReasons={reqReasons}
                  disabled={!helpers.can(userGroups.superAdmins)}
                  reqID={reqID}
                  value={reqStatusCode}
                  autoSaveCallBack={handleRequisitionUpdate} />
              </InputWrap>
            );
          })}
        </div>
      </WidgetType1>
       {/* Only show Billing Status for admin users, not billing role users */}
      {helpers.can(userGroups.superAdmins) && (
        <WidgetType1
          title="Billing Status"
          wrapStyles="width: 48%"
        >
          <div className={styles.inputList}>
            <InputWrap>
              <div style={{
                minHeight: '48px',
                display: 'flex',
                alignItems: 'center'
              }}>
                {reqBillStatusDesc}
              </div>
            </InputWrap>
          </div>
        </WidgetType1>
      )}
      </>
    );
  }
}

export default StatusWidgetContainer;
